import { bool } from "prop-types";

export interface VypocetBoduZahranicniSoutezeResult {
    body?: number;
    finale?: boolean;
}

export default class SoutUtils {

    /*
     Body ze soutěže se počítají se tak, že za každý poražený pár 1 bod
     Za postup do dalšího kola 2 body
     Za 1. místo 15, za 2. Místo 10 a za 3. Místo 5
     Když tedy pár vyhraje soutěž, kde bude celkem 6 párů a bude mít semifinále a finále získá:
     5 bodů za 5 poražených párů + 2 body za postup do dalšího kola + 15 bodů za 1. Místo, celkem tedy 22 bodů
     Pozor:  redance se nepočítá jako kolo
     */
    static vypocetBoduZahranicniSouteze(pocetParu: number, pocetKol: number, umisteniOd: number, umisteniDo: number, pocetKolektivnichClenu: number, parVeFinale: boolean): VypocetBoduZahranicniSoutezeResult {

        if (umisteniDo === 0) {
            umisteniDo = umisteniOd;
        }
        let body: number = undefined;
        let finale: boolean = undefined;
        if (pocetKol > 0 && umisteniOd > 0 && umisteniDo >= umisteniOd && umisteniDo <= pocetParu) {
            body = (pocetParu - umisteniDo); // body za porazene pary
            body = body + ((pocetKol - 1) * 2); // body za postup do dalsiho kola
            if (umisteniOd <= 3) {
                body = body + (5 * (4 - umisteniOd)); // body za 1., 2. a 3. misto
            }

            finale = parVeFinale && this.zapocitatFinale(pocetParu, pocetKolektivnichClenu, umisteniOd);
        }

        return {
            body: body,
            finale: finale
        };
    }


    /*
     2 1 – 2 žádné
     3 – 5 2 a více 1.
     6 -10 3 a více 1. – 2.
     11 – 15 3 a více 1. – 3.
     16 – 20 3 a více 1. – 4.
     21 - 25 3 a více 1. – 5.
     Více než 25
     */
    private static zapocitatFinale(pocetParu: number, pocetKolektivnichClenu: number, umisteniOd: number): boolean {

        let zapocitatDoPoradi = 0;
        if (pocetParu > 2 && pocetKolektivnichClenu > 1) {
            if (pocetKolektivnichClenu == 2) {
                if (pocetParu <= 5) {
                    zapocitatDoPoradi = 1;
                }
            } else {
                // pro pocetKolektivnichClenu >= 3
                if (pocetParu <= 5) zapocitatDoPoradi = 1;
                else if (pocetParu <= 10) zapocitatDoPoradi = 2;
                else if (pocetParu <= 15) zapocitatDoPoradi = 3;
                else if (pocetParu <= 20) zapocitatDoPoradi = 4;
                else if (pocetParu <= 25) zapocitatDoPoradi = 5;
                else zapocitatDoPoradi = 9999;

            }
        }

        return umisteniOd <= zapocitatDoPoradi;
    };

}